/*global BASE_URL, console, _, Modernizr*/
/*jshint browser:true, jquery:true, undef:true, multistr: true*/
$( document ).ready(function() {

    var browserWindow = $( this );

    // [Mortgage Calculator] ::start
    (function() {

        var _principalEl                   = $( '#principal' ),
            _downpaymentEl                 = $( '#downpayment' ),
            _interestEl                    = $( '#interest' ),
            _termYearsEl                   = $( '#term_years' ),
            _amortizationEl                = $( 'input[type=radio][name=amortization]' ),
            _amortizationViewEl            = $( '#amortization_view' ),
            _paymentViewEl                 = $( '#payment_view' ),
            _interestPaidViewEl            = $( '#interest_paid_view' ),
            _mortgageCalculationViewEl     = $( '#mortgage_calculation_view' ),
            _mortgageErrorMessageEl        = $( '#mortgage_error_message' ),
            _mortgageErrorMessageWrapperEl = $( '#mortgage_error_message_wrapper' );


        // mask principal, downpayment, _interestEl
        _principalEl.inputmask({alias: 'currency'});
        _downpaymentEl.inputmask({alias: 'currency'});
        _interestEl.inputmask({alias: 'numeric'});
        var _getMonthlyPayment = function( principal, downpayment, interest, termYears )
        {
            var interestTmp, num, den, mult, result;

            principal   = principal - downpayment;
            interestTmp = 1 + interest;
            num         = Math.pow( interestTmp, termYears );
            num         = interest * num;
            den         = Math.pow( interestTmp, termYears );
            den         = den - 1;

            if ( interest === 0 ){
                mult = 1 / termYears;
            } else {
                mult = num / den;
            }

            result = principal * mult;
            return Number( result );
        };

        var _getYearlyPayment = function( principal, downpayment, interest, termYears )
        {
            var monthlyPayment = _getMonthlyPayment( principal, downpayment, interest, termYears );
            return Number( monthlyPayment * 12 );
        };

        var _getInterest = function ( principal, downpayment, calculatedMortgage, termYears )
        {
            var result = Number( (calculatedMortgage * termYears) - (principal - downpayment) );
            if ( result < 0 ){
                result = 0;
            }
            return result;
        };

        var _calculateMortgage = function()
        {
            var principal   = _principalEl.inputmask('unmaskedvalue'),
                downpayment = _downpaymentEl.inputmask('unmaskedvalue'),
                interest    = ( _interestEl.val() / 100 ) / 12,
                termYears   = _termYearsEl.selectpicker( 'val' ) * 12,
                monthlyPayment,
                yearlyPayment,
                interestPaid;

            monthlyPayment = _getMonthlyPayment( principal, downpayment, interest, termYears );
            yearlyPayment  = _getYearlyPayment( principal, downpayment, interest, termYears );
            interestPaid   = _getInterest( principal, downpayment, monthlyPayment, termYears );

            return {
                monthlyPayment: monthlyPayment,
                yearlyPayment: yearlyPayment,
                interestPaid: interestPaid
            };

        };

        var _showErrorMessage = function( message )
        {
            if ( _mortgageCalculationViewEl.is(':visible') ) {
                _mortgageCalculationViewEl.addClass( 'hidden' );
                _mortgageErrorMessageWrapperEl.removeClass( 'hidden' );
            }
            _mortgageErrorMessageEl.text( message );
        };

        var _hideErrorMessage = function( forceHide )
        {
            if ( _mortgageCalculationViewEl.is(':hidden') || forceHide === true ) {
                _mortgageCalculationViewEl.removeClass( 'hidden' );
                _mortgageErrorMessageWrapperEl.addClass( 'hidden' );
            }
            _mortgageErrorMessageEl.text( '' );
        };

        var _view = function()
        {
            var calculatedMortgage = _calculateMortgage(),
                amortization,
                payment;

            if ( calculatedMortgage.monthlyPayment < 0 ) {
                return _showErrorMessage( 'Downpayment should not be more than principal amount' );
            } else if ( isNaN(calculatedMortgage.monthlyPayment) || isNaN(calculatedMortgage.yearlyPayment) || isNaN(calculatedMortgage.interestPaid) ) {
                return _showErrorMessage( 'Unable to compute mortgage.' );
            }

            _hideErrorMessage();

            amortization = _amortizationEl.filter(':checked').val();

            if ( amortization === 'Yearly' ) {
                payment = calculatedMortgage.yearlyPayment;
            } else {
                payment = calculatedMortgage.monthlyPayment;
            }

            _amortizationViewEl.text( amortization );

            _paymentViewEl.text( numeral(payment).format('$0,0.00') );
            _interestPaidViewEl.text( numeral(calculatedMortgage.interestPaid).format('$0,0.00') );

        };

        var _init = function()
        {
            _hideErrorMessage( true );

            _principalEl.on( 'input propertychange paste change', _view  );
            _downpaymentEl.on( 'input propertychange paste change', _view  );
            _interestEl.on( 'input propertychange paste change', _view  );
            _termYearsEl.on( 'change', _view  );
            _amortizationEl.on( 'change', _view );

            _view();

        };

        _init();

    })();
    // [Mortgage Calculator] ::end

});
